import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import AnimatedBackground from '../components/AnimatedBackground';
import { fireEvent } from '../utils/funnelEvents';
import ArticleStructuredData from '../components/ArticleStructuredData';
import ConsultantsHeader from '../components/ConsultantsHeader';

import ConsultantsHero from './consultants/ConsultantsHero';
import Workflow from './consultants/Workflow';
import PainPoints from './consultants/PainPoints';
import LocalFirst from './consultants/LocalFirst';
import ConsultantsPricing from './consultants/Pricing';
import ContactInfo from './consultants/ContactInfo';
import ConsultantsFAQ from './consultants/ConsultantsFAQ';

const ConsultantsPage = () => {
  const pageTitle =
    'File Organization for Consultants & Multi-Venture Founders | Sortio';
  const pageDescription =
    'Sortio is file organization software for consultants and multi-business founders. AI rules route client deliverables, grant narratives, and multi-business Downloads into the right folders. Per-client folder system with a fully local AI option (Ollama).';
  const keywords =
    'file organization for consultants, multi-client file management, client deliverables organization software, grant consultant file management, multi-business document organizer, founder file organization, AI rules for sorting client files, freelance client folder system';

  useEffect(() => {
    fireEvent('team_page_view', { vertical: 'consultants' });
  }, []);

  return (
    <>
      <Helmet>
        <title>{pageTitle}</title>
        <meta name="description" content={pageDescription} />
        <meta name="keywords" content={keywords} />
        <meta property="og:title" content={pageTitle} />
        <meta property="og:description" content={pageDescription} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.getsortio.com/for-consultants" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={pageTitle} />
        <meta name="twitter:description" content={pageDescription} />
        <link rel="canonical" href="https://www.getsortio.com/for-consultants" />
      </Helmet>
      <ArticleStructuredData
        title={pageTitle}
        description={pageDescription}
        datePublished="2026-05-12T00:00:00.000Z"
        dateModified="2026-05-12T00:00:00.000Z"
        authorName="Sortio Team"
      />

      <ConsultantsHeader />
      <ConsultantsHero />

      <div className="relative">
        <AnimatedBackground variant="business" />
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 relative z-10">
          <Workflow />
          <PainPoints />
          <LocalFirst />
          <ConsultantsPricing />
          <ConsultantsFAQ />
          <ContactInfo />
        </div>
      </div>
    </>
  );
};

export default ConsultantsPage;
